import { createIcon } from "@chakra-ui/react";

export const Monitor = createIcon({
  displayName: "Monitor",
  viewBox: "0 0 32 32",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 7.3a.76.76 0 0 1 .75.767V16.5H6.25V8.067A.76.76 0 0 1 7 7.3h18zm.75 11.5v1.533a.76.76 0 0 1-.75.767H7a.76.76 0 0 1-.75-.767V18.8h19.5zM7 5C5.345 5 4 6.375 4 8.067v12.266C4 22.025 5.345 23.4 7 23.4h5.423l-.375 2.3H9.625c-.623 0-1.125.513-1.125 1.15 0 .637.502 1.15 1.125 1.15h12.75c.623 0 1.125-.513 1.125-1.15 0-.637-.502-1.15-1.125-1.15h-2.423l-.375-2.3H25c1.655 0 3-1.375 3-3.067V8.067C28 6.375 26.655 5 25 5H7zm7.327 20.7.375-2.3h2.592l.375 2.3h-3.342z"
    />
  ],
  defaultProps: {
    "aria-label": "A monitor"
  }
});

export default Monitor;
